

$(document).ready(function() {


    var filterUrl = window.location.href;
    // function triggerFirstSwatch() {      
    //   setTimeout(function () {
    //     if (!$(body).hasClass('limited-edition-collection')) {
    //       if (filterUrl.includes('collections') && !filterUrl.includes('?') && !filterUrl.includes('filter')) {
    //           $('.collection-swatches-button:first').trigger('click');
    //       }
    //     } 
    //   },500);
    // }
    // // Function to handle shape filter
    // function triggerFirstShape() {      
    //   setTimeout(function () {
    //     if (!$(body).hasClass('limited-edition-collection')) {
    //       if (filterUrl.includes('collections') && !filterUrl.includes('?') && !filterUrl.includes('filter')) {
    //           $('.selection-filter-shape .mian_images:first').trigger('click');
    //       }
    //     } 
    //   },500);
    // }

    // Function to handle filtering swatches
    function filterSwatches() {
        $('.collection-swatches-button').each(function() {
            var swatchesFilterVal = $(this).attr('value');
            var splitswatchesFilterVal = swatchesFilterVal.split(' ')[0];
            if (filterUrl.indexOf(splitswatchesFilterVal) !== -1) {
              $(this).addClass('active');
            }
            if ($(this).hasClass('active')) {
              var filterText = $(this).find('.metal-text').text();
              $('.selected-swatches-filter-add').text(filterText);
              $('.selected-filter-value').find('.clear-button').css('display', 'flex');
            }
        });
    }

    // Function to handle shape filter
    function filterShape() {
        $('.selection-filter-shape .mian_images').each(function() {
            var shapeFilterVal = $(this).attr('value');
            var shapeFilterThis = $(this);
            var splitshapeFilterVal = shapeFilterVal.split(' ')[0];
            if (filterUrl.indexOf(splitshapeFilterVal) !== -1) {
              $(this).addClass('active');
            }
            if ($(this).hasClass('active')) {
              var filterText = $(this).find('.text_main_divs p').text();
              $('.selected-shape-filter-add').text(filterText);
              $('.selected-shape-filter').find('.clear-button').css('display', 'flex');
            }
            // Find the input with the matching value
              if (!$(".facets__accordion-section .facet-filter-name."+shapeFilterVal).length > 0) {
                var findDataHref = shapeFilterThis.find("a").attr("data-href");
                shapeFilterThis.find("a").attr("href",findDataHref);
              }
        });
    }
    // Function to handle updating links with query parameters
    // function updateLinks() {
    //     var filterUrl2 = window.location.href;
    //     var queryString = filterUrl2.split('?')[1];
    //     $('.image-with-text-flex .filter-collection-link').each(function() {
    //         var href = $(this).attr('href');
    //         var newHref;
    //         if (href) {
    //             if (href.includes('?')) {
    //                 var hrefSplitIndex = href.split('?')[0];
    //                 newHref = hrefSplitIndex + '?' + queryString;
    //             } else {
    //                 newHref = href + '?' + queryString;
    //             }
    //             $(this).attr('href', newHref);
    //         }
            
    //         if ($(this).parents('.mian_images').hasClass('active')) {
    //             var swatchText = $(this).find('.text_main_divs p').text();
    //             $('.selected-shape-filter').text(swatchText);
    //         }
    //     });
    // }
    
    // Initial call to filterSwatches and updateLinks functions
    //triggerFirstSwatch();
    filterSwatches();
    filterShape();
    // updateLinks();
    
    // Click event for collection-swatches-button
    $('.collection-swatches-button').click(function() {
        $('.collection-swatches-filter .collection-swatches-button').removeClass('active');
        $(this).addClass('active');
        var swatchesFilter = $(this).attr('value');
        $('.selected-swatches-filter-add').text(swatchesFilter);
        // $(this).closest(".collection-swatches-filter").find(".clear-button").show();
        $(this).closest(".collection-swatches-filter").find('.clear-button').css('display', 'flex');
      
        // Filter value
        $('.facets__accordion-section .facet-filter-name').each(function() {
            if ($(this).parents('.material-filters').length > 0) {
              if ($(this).is(":checked")) {
                  $(this).trigger('click');
              }
              var filterValue = $(this).attr('value');
              if (swatchesFilter === filterValue) {
                $(this).trigger('click');
              }
            }
        });
    
        // Update links with query parameters
        // setTimeout(function() {
        //     updateLinks();
        // }, 500);
    });
  
    // Click event for collection-shape-button
    $(document).on("click",".mian_images", function () {
        $('.selection-filter-shape .mian_images').removeClass('active');
        $(this).addClass('active');
        var swatchesFilter = $(this).attr('value');
        $('.selected-shape-filter-add').text(swatchesFilter);
        // $(this).closest(".selection-filter-shape").find(".clear-button").show();
        $(this).closest(".selection-filter-shape").find(".clear-button").css('display', 'flex');
        // Filter value
        $('.facets__accordion-section .facet-filter-name').each(function() {
            if ($(this).parents('.shape-filter-container').length > 0) {
              if ($(this).is(":checked")) {
                  $(this).trigger('click');
              }
              var filterValue = $(this).attr('value');
              if (swatchesFilter === filterValue) {
                $(this).trigger('click');
              }
            }
        });
    
        // Update links with query parameters
        setTimeout(function() {
            // updateLinks();
        }, 500);
    });
  
    //Filter Drawer click event on material
   $(document).on('click', '.material-filters .facet-filter-name', function() {
      $('.material-filters .facet-filter-name').not(this).prop('checked', false);
       var materialFilterVal = $(this).val();
       var outerThis = this;
        $('.collection-swatches-button').each(function() {
          var customMaterialVal = $(this).val();
          if(customMaterialVal == materialFilterVal){
              if(!$(this).hasClass('active')) {
                $(this).addClass('active');
              }
              else{
                 $(this).removeClass('active');
              }
          }
          else{
            $(this).removeClass('active');
          }
        });
   });
  // selection-filter-shape
  $(document).on("click",".selection-filter-shape .clear-button",function(){
    var cloesestDIV = $(this).closest(".selection-filter-shape");
    cloesestDIV.find(".mian_images.active").removeClass("active");
    cloesestDIV.find(".selected-shape-filter-add").text("");
    cloesestDIV.find(".clear-button").hide();
    
    // Uncheck any checked checkboxes within the shape filter container
    if($(".shape-filter-container").find(".facet-filter-name:checked")){
      $(".shape-filter-container").find(".facet-filter-name:checked").trigger("click");
    }
  });
  // collection-swatches-filter
  $(document).on("click",".collection-swatches-filter .clear-button",function(){
    var cloesestDIV = $(".collection-swatches-filter");
    cloesestDIV.find(".collection-swatches-button").removeClass("active");
    cloesestDIV.find(".selected-swatches-filter-add").text("");
    cloesestDIV.find(".clear-button").hide();
    
    // Uncheck any checked checkboxes within the shape filter container
    if($(".material-filters").find(".facet-filter-name:checked")){
      $(".material-filters").find(".facet-filter-name:checked").trigger("click");
    }
    
     // material filters 
    $('.collection__inner').find('.material-filters .facets__item.active').removeClass("active");
    $('.selected-filter-value').find('.clear-button').css('display', 'none');
    if (!$(this).hasClass('active')) {
          $('.selected-swatches-filter-add').text(''); // Clear the text if the item is no longer active
      }
  });
   $(document).on("click", ".material-filters .facets__item", function () {
      $(this).addClass('active'); 
      $(this).siblings().removeClass("active");
      if ($(this).hasClass('active')) {
          var filterText = $(this).find('.checkbox__label').text() // Get the filter text
          $('.selected-swatches-filter-add').text(filterText); // Update the target element's text
          $('.selected-filter-value').find('.clear-button').css('display', 'flex');
      } else {
          $('.selected-swatches-filter-add').text(''); // Clear the text if the item is no longer active
      }
  });
  //collection redirection scroll
  // $('.filter-collection-link').click(function() {
  //   var collectionFilterURL = $(this).attr('href') + '#main-text-with-image-block';
  //   if (window.location.hash !== '#main-text-with-image-block') {
  //     $(this).attr('href', collectionFilterURL);
  //   }
  //   setTimeout(function() {
  //       window.location.hash = '#main-text-with-image-block'; 
  //   }, 1000);
  // });


  //Get the custom filter section
  // if (~window.location.href.indexOf("/collections") && $('.collection-custom-filter-section').length > 0){
  //   $('.collection-custom-filter-section').insertAfter('.collection-swatches-filter-main .collection-swatches-filter');
  //   $('.collection-custom-filter-section').show();
  // }

  //Collection custom filter
  $('.custom-filter-image-wrapper').on('click',function () {
    var selectedFilterVal = $(this).attr('data-filter-value');
    $(this).parents('.collection-custom-filter-section').find('.selected-filter-name').text(selectedFilterVal);
    $(this).addClass('active');
    $(this).siblings().removeClass('active');

    //Filter Drawer carta size 
      $('.facets__accordion-section .facet-filter-name').each(function() {
          if ($(this).parents('.carat-size-filter').length > 0) {
            if ($(this).is(":checked")) {
                $(this).trigger('click');
            }
            var filterSizeValue = $(this).attr('value');
            if (selectedFilterVal === filterSizeValue) {
              $(this).trigger('click');
            }
          }
      });
  });
  filterCarats();
  // Function to find active carat size
    function filterCarats() {
        $('.custom-filter-image-wrapper').each(function() {
            var activeFilterVal = $(this).attr('data-filter-value');
            var splitactiveFilterVal = activeFilterVal.split(' ')[0];
            var startIndex = filterUrl.indexOf("stone+size=");
            var substring = filterUrl.substring(startIndex);
            var endIndex = substring.indexOf("&");
            if (endIndex === -1) {
                endIndex = substring.length;
            }
            var stoneSize = substring.substring(11, endIndex);
            var digitValue = parseFloat(stoneSize.match(/\d+(\.\d+)?/));
            if (digitValue == splitactiveFilterVal) {
              $(this).addClass('active');
            }
            if ($(this).hasClass('active')) {
              $('.collection-custom-filter-section .selected-filter-name').text(activeFilterVal);
            }
        });
    }
  
  //slideshow carousel
    $('.slideshow-carousel').owlCarousel({
      nav: true,
      navText: [
        '<i class=\'fa fa-angle-left\'></i>',
        '<i class=\'fa fa-angle-right\'></i>'
      ],
      dots: false,
      loop: false,
      touchDrag: false,
      mouseDrag: false,
      margin:15,
      rewind:true,
      responsive: {
        0: {
          items: 1
        },
        1200: {
          items: 1
        }
      }
    });
  
  // slick collection swatches filter
//     $('.hero-icons-slider .image-with-text-flex').slick({
//     dots: false,
//     slidesToShow: 10,
//     arrows: false,
//     infinite: false,
//     speed: 300,
//     responsive: [
//         {
//             breakpoint: 1200,
//             settings: {
//                 slidesToShow: 8,
//                 slidesToScroll: 1,
//                 rows: 2 // Set rows to 2 for two rows at this breakpoint
//             }
//         },
//         {
//             breakpoint: 768,
//             settings: {
//                 slidesToShow: 5,
//                 slidesToScroll: 1,
//                 rows: 1 // Reset rows to 1 for one row at this breakpoint
//             }
//         },
//         {
//             breakpoint: 400,
//             settings: {
//                 slidesToShow: 3,
//                 slidesToScroll: 1,
//                 rows: 1 // Reset rows to 1 for one row at this breakpoint
//             }
//         }
//     ]
// });
  
  // slick slider collection
  // $('.collection-slider .card-product-slider__wrapper').slick({
  //     // rows: 2,
  //     dots: false,
  //     arrows: false,
  //     infinite: false,
  //     adaptiveHeight: false,
  //     speed: 300,
  //     responsive: [
  //      {
  //        breakpoint: 9999,
  //        swipe: false,
  //        draggable: false,
  //        settings: "unslick"
  //     },
  //     {
  //       breakpoint: 990,
  //       settings: {
  //           slidesToShow: 3,
  //           slidesToScroll: 1
  //       },
  //     },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //           slidesToShow: 2,
  //           slidesToScroll: 1
  //       },
  //     },
  //   ],
  // });


  // Upsell product code 
  var sizeTitle = $('.size-lineitem-title').attr('size-title');
  
  function closePopup(element) {
    element.parents('.upsell-product').removeClass('popup-open');
  }
  
  //cart bubble update
  function cartBubbleUpdate(){
    setTimeout(function () {
      var bubbleCount = $('#cart-counter .cart-count-badge').text();
      $('.cart-drawer .cart-item-count').text(bubbleCount);
    }, 1000);
  }
  
  //update bubble on click add to cart
  $('.product__form [name="add"]').on('click', function() {
    cartBubbleUpdate();
  });
  
  //variant dropdown ajax
  $('.upsell_variant_select').change(function () {
     var selectedVariantId = $(this).find(':selected').attr('option-variant-id');
      $(this).parents('.upsell-product-container').find('.upsell-product-ajax').attr('upsell-product-variant', selectedVariantId);
      $(this).parents('.free-gift-product-container').find('.free-gift-product-btn').attr('upsell-product-variant', selectedVariantId);

      // upsell product src image change
     var selectedVariantImage = $(this).find(':selected').attr('option-variant-image');
      $(this).parents('.upsell-product-container.v1').find('.upsell-product-image img').attr('src', selectedVariantImage);
      $(this).parents('.free-gift-product-container').find('.free-gift-product-image img').attr('src', selectedVariantImage);

      // upsell product price replace
       var selectedValue = $(this).find(':selected').attr('option-variant-price');
      $(this).parents('.upsell-product-container').find('.upsell-product-price .price_product').text(selectedValue);
      $(this).parents('.free-gift-product-container').find('.free-gift-product-price').text(selectedValue);
  });
   $('.upsell-product-container.v2 .upsell_variant_select').change(function () {
     // Get the selected variant image
      var selectedPopVariantImage = $(this).find(':selected').attr('option-variant-id');
      // Find the index of the selected variant image
      var selectedPopIndex = $('.upsell-product-container.v2 .upsell-product-image[data-pop-variant-id="' + selectedPopVariantImage + '"]').attr('data-pop-variant-index');
      // Trigger Owl Carousel to the selected index
      // $('.upsell-product-container.v2 .upsell-popup-image-container').trigger('to.owl.carousel', [selectedPopIndex, 0]);
       if ($('.upsell-product-container.v2 .upsell-product-variant:not(.upsell-size-meta-data)').length > 0) {
          $('.upsell-product-container.v2 .upsell-popup-image-container').trigger('to.owl.carousel', [selectedPopIndex, 0]);
        }
   });
  //upsell product ajax
  $(document).on("click",".upsell-product-btn",function() {
    var variantID = $(this).attr('upsell-product-variant');
    addToCartJS(1,variantID,$(this));
  });
  
  //Upsell Popup ajax 
  $(document).on("click",".upsell-product-btn-popup",function() {
    var variantPopupID = $(this).attr('upsell-product-variant');
     var variantQTY = $(this).parents('.upsellproduct-popup-wrapper').find('[name="quantity"]').val();
    addToCartJS(variantQTY,variantPopupID,$(this));
    closePopup($(this));
  });
  
  function addToCartJS(qty, variantID, btn) {
    // Open the cart drawer
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionsToRender = cartDrawer.getSectionsToRender().map(section => section.section);
    var sections_url = window.location.pathname;
    var selectedOptionValue;
    var metaSizeCartVal = $(btn).attr("meta-size-cart-value");
    // if($(btn).parents('.upsell-product-container').find('.upsell-size-meta-data').length > 0 ){
    //   selectedOptionValue = $(btn).parents('.upsell-product-container').find('.upsell-size-meta-data .upsell_variant_select').val();
    // }
     var $upsellVariantSelectMain = $(btn).parents('.upsell-product-container').find('.upsell-size-meta-data .upsell_variant_select_main[style=""]');
    // If found, get the `.upsell_variant_select` value
    if ($upsellVariantSelectMain.length > 0) {
      selectedOptionValue = $upsellVariantSelectMain.find('.upsell_variant_select').val();
    }
    else if($(btn).parents('.free-gift-product-container').find('.upsell-size-meta-data').length > 0){
      selectedOptionValue = $(btn).parents('.free-gift-product-container').find('.upsell-size-meta-data .upsell_variant_select').val();
    }
    else if(typeof metaSizeCartVal !== 'undefined' && metaSizeCartVal !== null){
      selectedOptionValue = metaSizeCartVal; //QUICK ADD get meta size line item value from add to cart button
    }
    else{
      selectedOptionValue = '';
    }
    // Send request to add item to cart
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ "quantity": qty, "id": variantID, properties: {"Size": selectedOptionValue}, "sections" : sectionsToRender, "sections_url" : sections_url})
    })
    .then(response => response.json())
    .then(response => {
      if (jQuery('body').hasClass('ajax-cart-type-drawer')) {
        cartDrawer.renderContents(response);
        cartDrawer.open();
        cartBubbleUpdate();
      } else {
        window.location.href = "/checkout";
      }
    })
    .catch(error => {
        console.error("Error adding item to cart:", error);
    });
  }

  
  // //size selector button
  // if ($('body').hasClass('template--product')){
  //    var interval = setInterval(function() {
  //       if($("#ymq-box").length && $('.product__form [name="add"]').attr('disabled') == undefined) {
  //           $('.product__form [name="add"]').hide();
  //           $('.size-selector-box-button').show();
  //           // Loop through each .ymq-options-button-input
  //             $('#ymq-box .ymq-options-button-input').each(function() {
  //                 // Check if the current input is checked
  //                 if ($(this).prop('checked')) {
  //                   // Trigger the click event for the label associated with this input
  //                   $(this).next('.ymq-options-button-label').click();
  //                 }
  //             });
  //             $('#ymq-box .ymq-error-item').hide();
  //             $('#ymq-box .ymq-options-button-label').on('click', function() {
  //               $('.product__form [name="add"]').show();
  //               $('.size-selector-box-button').hide();
  //               $('#ymq-box .ymq-error-item').show();
  //             });
  //         clearInterval(interval);
  //       }
  //     }, 100);
  // }
  //sold out text append on cart button
   if ($('body').hasClass('template--product')){
     var interval2 = setInterval(function() {
       if($('.product__form [name="add"]').attr('disabled') !== undefined) {
         // console.log('hello');
         // var soldOutText = $('.hidden_sold_out_text').text();
         // $('.product__form [name="add"]').text(soldOutText); 
         // $('.sold-out-text-class').text(soldOutText);
         // $('.sold-out-text-class').attr('disabled','disabled');  
         clearInterval(interval2);
       }
     }, 100);
   }
  //Upsell product popup functionality
  $('.popup-add-event').on('click', function() {
    $(this).parents('.upsell-product').addClass('popup-open');
     //Upsell popup media image carousel
    $(this).closest('.upsell-product').find('.upsell-popup-image-container').owlCarousel({
        nav: true,
        dots: false,
        loop: false,
        margin:15,
        responsive: {
          0: {
            items: 1
          },
          1200: {
            items: 1
          }
        }
      });
  });
  $('.popup-close-event').on('click', function() {
    closePopup($(this));
  });
    
  // upsell product cart drawer
   $('.upsell-product-cart-drawer').owlCarousel({
      nav: true,
      dots: false,
      loop: false,
      margin:15,
      responsive: {
        0: {
          items: 2
        },
        1200: {
          items: 2
        }
      }
    });

   // gift product upsell cart drawer
  $(".gift-product-cart-drawer").owlCarousel({
    nav: false,
    dots: true,
    loop: false,
    margin: 15,
    responsive: {
      0: {
        items: 1,
      },
      1200: {
        items: 1,
      },
    },
  });

  //size selector button
  if ($('body').hasClass('template--product')){
     var interval = setInterval(function() {
        if($(".size-lineitem-wrapper").length && $('.product__form [name="add"]').attr('disabled') == undefined) {
            $('.product__form [name="add"]').hide();
          
            $('.product__form .shopify-payment-button').addClass("disable-button");
         
            $('.size-selector-box-button').show();
            clearInterval(interval);
        }
        else{
           $('.product__form [name="add"]').show();
            clearInterval(interval);
        }
      }, 100);
  }
  
  //Size line item append input under form
  $(document).on('click','.size-line-item-options', function () {
    $(this).addClass('active');
    $(this).siblings().removeClass('active');

    //size selector button
    $('.product__form [name="add"]').show();
    $('.product__form .shopify-payment-button').show();
    $('.product__form [name="add"]').css('pointer-events','auto');
     $('.product__form .shopify-payment-button').removeClass("disable-button");
    $(".size-selector-box-button,disbaled-cta-button").hide();
    $(this).closest(".bundle-popup-section").find('.size-selector-box-button').hide();
    var lineItemVal = $(this).attr('data-meta-size-option');
    $('.product__form .product-size-lineitem-input').val(lineItemVal);
  });

  //Hide shipping product
  if (~window.location.href.indexOf("/products/shipping-protection")){
    window.location.href = "/";
  }

  //shape slider
  $('.template--index .image-with-text-flex').owlCarousel({
      nav: false,
      dots: false,
      loop: true,
      touchDrag: true,
      mouseDrag: true,
      margin: 30,
      rewind:true,
      responsive: {
        320:{
          items: 3,
          margin: 15
        },
        371:{
          items: 5,
          margin: 15
        },
        576:{
          items: 6,
          margin: 20
        },
        768:{
          items: 7
        },
        992:{
          items: 8
        },
        1441: {
          items: 10
        }
      }
    });

   $('.search-icon-text').on('click', function() {
    var $searchDrawer = $(this).closest('.header__utils-item').find('.search-drawer-product-main');
    var $searchVariant = $(this).closest('.header__utils-item').find('.search-variant-slider');
    $searchDrawer.css('opacity', 0);
    setTimeout(function() {
    $searchDrawer.css('opacity', 1);
        $searchDrawer.slick({
          infinite: false,
          slidesToShow: 5,
          slidesToScroll: 1,
          autoplay: false,
          // autoplaySpeed: 5000,
          pauseOnHover: false,
          arrows: true,
          dots: false,
          centerMode: false,
           prevArrow: '<button type="button" class="slick-prev"><svg data-v-7ad53488="" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="x-icon x-icon--l"><path data-v-7ad53488="" d="M5.19995 6.5L2.69995 4L5.19995 1.5" stroke="currentColor" stroke-width="0.4" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
          nextArrow: '<button type="button" class="slick-next"><svg data-v-7ad53488="" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="x-icon x-icon--l"><path data-v-7ad53488="" d="M2.69995 6.5L5.19995 4L2.69995 1.5" stroke="currentColor" stroke-width="0.4" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
          responsive: [
             {
                breakpoint: 990,
                settings: {
                    slidesToShow: 4,
                    infinite: true,
                    autoplay: false,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    infinite: true,
                    autoplay: false,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    infinite: true,
                }
            },
            {
                breakpoint: 0,
                settings: {
                    slidesToShow: 2,
                    infinite: true,
                }
            }
          ]
        });
    }, 200);
    $searchVariant.css('opacity', 0);
    setTimeout(function() {
    $searchVariant.css('opacity', 1);
      $searchVariant.slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        pauseOnHover: true,
        arrows: true,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev"><svg data-v-7ad53488="" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="x-icon x-icon--l"><path data-v-7ad53488="" d="M5.19995 6.5L2.69995 4L5.19995 1.5" stroke="currentColor" stroke-width="0.4" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg data-v-7ad53488="" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="x-icon x-icon--l"><path data-v-7ad53488="" d="M2.69995 6.5L5.19995 4L2.69995 1.5" stroke="currentColor" stroke-width="0.4" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
      });
    }, 200);
});
// search click slick slider add product 
//   $('.search-icon-text').on('click', function() {
//     var $searchDrawer = $(this).closest('.header__utils-item').find('.search-drawer-product-main');
//     var $searchVariant = $(this).closest('.header__utils-item').find('.search-variant-slider');
//       $searchDrawer.slick({
//           infinite: false,
//           slidesToShow: 5,
//           slidesToScroll: 1,
//           autoplay: false,
//           // autoplaySpeed: 5000,
//           pauseOnHover: false,
//           arrows: true,
//           dots: false,
//           centerMode: false,
//           responsive: [
//              {
//                 breakpoint: 990,
//                 settings: {
//                     slidesToShow: 4,
//                     infinite: true,
//                     autoplay: false,
//                 }
//             },
//             {
//                 breakpoint: 767,
//                 settings: {
//                     slidesToShow: 3,
//                     infinite: true,
//                     autoplay: false,
//                 }
//             },
//             {
//                 breakpoint: 600,
//                 settings: {
//                     slidesToShow: 2,
//                     infinite: true,
//                 }
//             },
//             {
//                 breakpoint: 0,
//                 settings: {
//                     slidesToShow: 2,
//                     infinite: true,
//                 }
//             }
//           ]
//       });
//     $searchDrawer.css('opacity', 0);
//       setTimeout(function() {
//         $searchDrawer.css('opacity', 1);
//       }, 500);

//       $searchVariant.slick({
//           infinite: false,
//           slidesToShow: 3,
//           slidesToScroll: 1,
//           autoplay: true,
//           autoplaySpeed: 1000,
//           pauseOnHover: true,
//           arrows: true,
//           dots: false,
//           prevArrow: '<button type="button" class="slick-prev"><svg data-v-7ad53488="" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="x-icon x-icon--l"><path data-v-7ad53488="" d="M5.19995 6.5L2.69995 4L5.19995 1.5" stroke="currentColor" stroke-width="0.4" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
//           nextArrow: '<button type="button" class="slick-next"><svg data-v-7ad53488="" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="x-icon x-icon--l"><path data-v-7ad53488="" d="M2.69995 6.5L5.19995 4L2.69995 1.5" stroke="currentColor" stroke-width="0.4" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
//       });
    
//     $searchVariant.css('opacity', 0);
//     setTimeout(function() {
//       $searchVariant.css('opacity', 1);
//     }, 500);
// });
  
  //************Start code for Quick Add Funactionality*********
    
  // size poppup colse icon 
    $(".size-popup-variants-list-title .size-popup-variants-icon").click(function(){
        $("body").css("overflow", "");
        $(".size-popup-list-content").removeClass("is-visible");
        $(".size-popup-variants-cover ul li").removeClass("active");
        $(".size-popup-variants-list-button button").addClass("disable");
        $(".size-popup-variants-list-button").find(".size-add-to-cart-variants").removeClass("active");
        $(".size-popup-variants-list-button").find(".size-button-variants").removeClass("active");
    });
 
    //Trigger default plus icon(Mobile)
      $(document).on("click",".product-ajax-container .ajax-button-with-sizevariant",function () {
        $(this).closest(".card-product").find(".card-product__sizes-btn-toggle").trigger("click");
      });
  
    //Desktop/Mobile ajax button without sizevariant
      $(document).on("click",".ajax-button-without-sizevariant",function () {
        var sizeVariant = 1;
        var selectedVariantID = $(this).attr("meta-selected-variantid");
        addToCartJS(sizeVariant, selectedVariantID, $(this));
      });

   // size and carat select variants
    $(document).on("click",".size-popup-variants-list .size-popup-variants",function (){
      //carat size and meta size active add remove 
      $(this).closest('.card-product-variants').find('.size-popup-variants.active').removeClass('active');
      $(this).addClass("active");
      
      var parentDIV = $(this).closest(".card-product");
      var selectSizeButton = parentDIV.find('.size-button-variants');
      
      //Change text of button 
        var metafieldSizeText = $(this).closest(".card-product").find('.size-button-variants').attr('select-size');
        if($(this).hasClass('carat-size-variants')){
          selectSizeButton.text(caratSizeText);
          //Store Carat variant id
          var variantSize = $(this).attr("data-size-variants");
          $(this).closest(".size-popup-variants-list").find(".size-add-to-cart-variants").attr("data-size-cart-variants", variantSize);
        }
        else if ($(this).hasClass('line-item-size-variants')){
          selectSizeButton.text(metafieldSizeText);
        }
        var caratSizeText  = $(this).closest(".size-popup-variants-list").find(".size-button-variants").attr("select-size-text");
        $(this).closest(".size-popup-variants-list").find(".size-button-variants").text(caratSizeText);

      

      //Hide/show carat-size/meta-size slider section
      parentDIV.find(".size-popup-variants-list.desktop .meta-size-variants-main").addClass("active");
      parentDIV.find(".size-popup-variants-list.desktop .size-popup-variants-slider").addClass("active");

      // Mobile disable/active add to cart button
      var mobileParentDIV = $(this).closest('.size-popup-variants-list.mobile');
      var mobileSizeParentDIV = $(this).parents(".card-product__sizes-content")
      if(mobileParentDIV.find('.mobile-carat-size-variant').length > 0 && mobileParentDIV.find('.line-item-size-variants').length > 0){
        if(mobileParentDIV.find('.mobile-carat-size-variant.active').length > 0 && mobileParentDIV.find('.line-item-size-variants.active').length > 0){
           $(this).find(".size-popup-variants-list-button button").removeClass("disable");
          mobileSizeParentDIV.find(".size-popup-variants-list .size-add-to-cart-variants").addClass("active");
          mobileSizeParentDIV.find(".size-popup-variants-list-button .size-button-variants").addClass("active");
        }
      }
      else if(mobileParentDIV.find('.mobile-carat-size-variant').length > 0 || mobileParentDIV.find('.line-item-size-variants').length > 0){
        if($(this).hasClass('active')){
          $(this).find(".size-popup-variants-list-button button").removeClass("disable");
          mobileSizeParentDIV.find(".size-popup-variants-list .size-add-to-cart-variants").addClass("active");
          mobileSizeParentDIV.find(".size-popup-variants-list-button .size-button-variants").addClass("active");
        }
      }
      
      // show/hide add to cart button
      if($(this).hasClass('line-item-size-variants')){
       $(this).parents(".card-product").find(".size-popup-variants-list.desktop .size-add-to-cart-variants").addClass("active");
       $(this).parents(".card-product").find(".size-popup-variants-list.desktop .size-button-variants").addClass("active");

      // Store Meta size value in add to cart button(desktop/mobile)
       var variantcaratSize = $(this).attr("carat-meta-size-option");
       $(this).closest(".size-popup-variants-list").find(".size-add-to-cart-variants").attr("meta-size-cart-value", variantcaratSize);
      }
    });
  
  $(document).on("click",".size-add-to-cart-variants",function () {
    $("body").css("overflow", "");
    $(".size-popup-list-content").removeClass("is-visible");
    // $(".size-popup-variants-list-button").find(".size-add-to-cart-variants").removeClass("active");
    // $(".size-popup-variants-list-button").find(".size-button-variants").removeClass("active");
    //ajax cart function
    var sizeVariantQTY = 1;
    var caratSizeVarianatID;
    var metaSelectedVariantID = $(this).attr('meta-selected-variantid');
    if (typeof metaSelectedVariantID !== 'undefined' && metaSelectedVariantID !== null) {
      caratSizeVarianatID = metaSelectedVariantID;
    }else{
      caratSizeVarianatID = $(this).attr("data-size-cart-variants");
    }
    addToCartJS(sizeVariantQTY, caratSizeVarianatID, $(this));
  });
  //End code for quick add

  //product size add to cart
    $(".size-popup-variants-list.desktop .card-product-variant-slider").owlCarousel({
      nav: true,
      dots: false,
      loop: false,
      touchDrag: true,
      mouseDrag: true,
      margin: 0,
      rewind: true,
      responsive: {
        320: {
          items: 2,
        },
        371: {
          items: 3,
        },
        991: {
          items: 4,
        },
        1441: {
          items: 4,
        },
      },
    });

   //Set country size selected on basis of country visitors


  //product page trustpilot review slider
   $('.main-product__tab').on('click', function() {
        $('.main-product__tab-content .trustpilot-review-content-main').owlCarousel({
          nav: true,
          dots: false,
          loop: true,
          touchDrag: false,
          mouseDrag: false,
          margin: 0,
          rewind: false,
          responsive: {
            320: {
              items: 1,
            },
            575: {
              items: 2,
            },
            770: {
              items: 1,
            },
            1199: {
              items: 2,
            },
            1441: {
              items: 2,
            },
          },
      });
    });

  //product page trustpilot review slider
   $('.main-product__tab-content .trustpilot-review-content-main').owlCarousel({
          nav: true,
          dots: false,
          loop: true,
          touchDrag: false,
          mouseDrag: false,
          margin: 0,
          rewind: false,
          responsive: {
              320: {
                  items: 1,
              },
              575: {
                  items: 2,
              },
              770: {
                  items: 1,
              },
              1199: {
                  items: 2,
              },
              1441: {
                  items: 2,
              },
          },
      });

      //Review tab open code
      $('.product__grid__item--content .main-product__tab_review').addClass('active');
      $('.product__grid__item--content .main-product__tab-content_review').css({'display': 'inline-block'});
  
      $('.main-product__tab-content .trustpilot-review-content-main').css('opacity', '0');
      
      setTimeout(function() {
          $('.main-product__tab-content .trustpilot-review-content-main').css('opacity', '1');
      }, 1000);

  //collection page trustpilot review slider
    $(".trustpilot-review-section .trustpilot-review-content-main").owlCarousel({
      nav: true,
      dots: false,
      loop: true,
      touchDrag: false,
      mouseDrag: false,
      margin: 0,
      rewind: false,
      responsive: {
        320: {
          items: 1,
        },
        480: {
          items: 2,
        },
        850: {
          items: 3,
        },
        1441: {
          items: 3,
        },
      },
    });
  
   // function refreshContent() {
  //   console.log("Refreshing content");    
  //   initializeCarousel();
  // }
  
  // initializeCarousel();
  //   $('.facets__accordion input').on("click", function () {
  //   console.log("Facets accordion input clicked");
  //   // refreshContent();
  //    $('.collection__grid').find('.collection__actions').addClass('1');
    
  // });
  
  // product alphabet text
   $(document).on("click", ".personalised-main li", function () {
      // Add 'active' class to the clicked element
     var parentDIV = $(this).closest('.personalised-option');
      $(this).addClass('active');
      $(this).siblings().removeClass("active");
      var product_Letters = $(this).attr('data-option-value');
       parentDIV.find(".selected-switchbutton-input").val(product_Letters);
       parentDIV.find('.selected-switchbutton').text(product_Letters);
    });

   //enabled/disbaled CTA button
    var engravingInputs = $('.product__form').find('.engraving-text-input');
    if ($(engravingInputs).length > 0) {
      $(".product-selector__submit").addClass('hidden');
      $(".engaring-text-button").removeClass('hidden');
      $('.product__form .shopify-payment-button').addClass('hidden');
    }else {
      $(".product-selector__submit").removeClass('hidden');
      $('.product__form .shopify-payment-button').removeClass('hidden');
    }

  //Product personalised options
  //character count code
  $('.engraving-text-input').on('input', function() {
      // Get the current length of the input value
      var currentLength = $(this).val().length;
      var maxLength = parseInt($(this).attr('maxlength'));
      var remainingCharacters = maxLength - currentLength;
      $(this).closest('.personalised-option').find('.character-count-number').text(remainingCharacters);

      //enabled/disbaled CTA button
     if (currentLength > 0) {
        $('.product__form').find('.product-selector__submit').removeClass('hidden');
        $(".engaring-text-button").addClass('hidden');
        $('.product__form .shopify-payment-button').removeClass('hidden');
      } else {
        $('.product__form').find('.product-selector__submit').addClass('hidden');
        $(".engaring-text-button").removeClass('hidden');
        $('.product__form .shopify-payment-button').addClass('hidden');
      }
  });

  $(document).on("click", ".personalised_tab-content .letter-text", function () {
    // Add 'active' class to the clicked element
    $(".personalised_tab-content .letter-text.active").removeClass("active");
    $(this).addClass("active");
    var product_Letters = $(this).attr("product-Letters");
    $(".personalised_tab-item").find(".selected-switchbutton").attr("engraving-Letters", product_Letters);
    $(".selected-switchbutton-input").attr("value", product_Letters);
    $(".personalised_tab-item").find(".selected-switchbutton").text(product_Letters);
  });
  
  // $(document).on("click", ".personalised_tab-item .personalised_tab", function () {
  //   // Toggle the 'active' class on the corresponding content
  //   $(this).closest(".personalised_tab-item").find(".personalised_tab-content").toggleClass("active");
  // });
      $(document).on("click", ".personalised_tab-item .personalised_tab", function (e) {
          $(this).closest(".personalised_tab-item").find(".personalised_tab-content").toggleClass("active");
          e.stopPropagation();
      });

      $(document).on("click", ".personalised_tab-content li, body", function () {
          $(".personalised_tab-content").removeClass("active");
      });

  //Number of items update
  updateLineItems();
  
   //Number of coins code
    var clickTimeout;
    $(document).on("click",".personalised-number-of-items",function() {
       clearTimeout(clickTimeout);
      clickTimeout = setTimeout(updateLineItems, 0); // Adjust the delay time here (in milliseconds)
    });

  // announcement bar
    $('.announcement-bar-content').slick({
        vertical: true,
        verticalSwiping: true,
        arrows: true, // Fixed typo: 'arroe' to 'arrows'
        dots: false, // Optional: Add dots for navigation
        infinite: true, // Optional: Enable infinite scrolling
        speed: 300, // Animation speed
        autoplay: true, // Enable autoplay
        autoplaySpeed: 2000, // Speed of autoplay
        slidesToShow: 1, // Number of slides to show at once
        slidesToScroll: 1, // Number of slides to scroll
        responsive: [
            {
                breakpoint: 768, // Tablet breakpoint
                settings: {
                    arrows: false, // Fixed typo: 'arroe' to 'arrows'
                    // You can add other settings here if needed
                }
            }
        ]
    });
    
   // Handle the click event on the prev button
   $('.product__media .swiper-button-prev').on('click', function () {
    // Find all slides and loop through them
    if($('.swiper-thumbs .swiper-slide-prev').length > 0){
      console.log("testingggggg")
    }
});

// Upsell product add button disable
function updateButtonClass(selectElement) {
var selectedOption = $(selectElement).find('option:selected');
var upsellProductBtn = $(selectElement).closest('.upsell-product-container').find('.upsell-product-btn');
if ($(selectedOption).attr('data-select-value')) {
    upsellProductBtn.addClass('disable'); // Add 'disble' class if "Select" is chosen
  }else {
    upsellProductBtn.removeClass('disable'); // Remove 'disble' class for valid selection
  }
}
// On dropdown change, check the selected value and update the button
$(document).on('change', '.upsell_variant_select', function() {
  updateButtonClass(this);
});


// Number of coins lineitem plus/minus code
function updateLineItems() {
  var variantValue = parseInt($('.personalised-number-of-items.active').attr('data-option-value'));
  var lineItemCount = $('.personalised-gemstone-item').length;
  // Remove extra items if variantValue is less than the current line item count
  if (variantValue < lineItemCount) {
      $('.personalised-gemstone-item:gt(' + (variantValue - 1) + ')').remove();
  } else if (variantValue > lineItemCount) {
      for (var i = lineItemCount + 1; i <= variantValue; i++) {
          var newItem = $('.personalised-gemstone-item').first().clone();
          newItem.find('.personalised-item-number').text('#' + i + ' *');
          newItem.find('input').each(function() {
              var inputName = $(this).attr('name');
              var parts = inputName.split('[');
              var dynamicValue = parts[1].substring(0, parts[1].length - 1);
              var newInputName = parts[0] + '[' + dynamicValue + i + ']'; // Appending 'i' to the dynamic value
              $(this).attr('name', newInputName);
          });
          $('.personalised-gemstone-item:last').after(newItem);
      }
  }
}

//Motivator Product JS Start
var motivatorProduct = false;
document.addEventListener('DOMContentLoaded', function () {
document.addEventListener('click', function (event) {
  var target = event.target;
  if (target.classList.contains('click_gift')) {
    var isChecked = target.checked;
    fetch('/cart.json')
      .then(response => response.json())
      .then(data => {
        var items = data.items;
        var foundMotivatorProduct = items.some(item => item.handle === motivatorProductHandle);
        if (isChecked && !foundMotivatorProduct) {
          addMotivatorProduct(motivatorProductVariantID);
        } else if (!isChecked) {
          removeMotivatorProduct(motivatorProductVariantID);
        }
      });
  }
});
});

function addMotivatorProduct(motivatorProductVariantID) {
  var xhr = new XMLHttpRequest();
  var url = "/cart/add.js";
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var parsedState = JSON.parse(xhr.responseText);
      document.querySelector('cart-drawer').renderContents(parsedState);
      $(".click_gift").prop("checked", true);
    }
  };
  var cartDrawer = document.querySelector('cart-drawer');
  var sectionsToRender = cartDrawer.getSectionsToRender().map(section => section.section);
  var sections_url = window.location.pathname;
  var data = JSON.stringify({"quantity": 1, "id": motivatorProductVariantID, "sections" : sectionsToRender, "sections_url" : sections_url });
  xhr.send(data);
}

function removeMotivatorProduct(motivatorProductVariantID) {
  var cartDrawer = document.querySelector('cart-drawer');
  var xhr = new XMLHttpRequest();
  var url = "/cart/change.js";
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var parsedState = JSON.parse(xhr.responseText);
      document.querySelector('cart-drawer').renderContents(parsedState);
      $(".click_gift").prop("checked", false);
    }
  };
  var cartDrawer = document.querySelector('cart-drawer');
  var sectionsToRender = cartDrawer.getSectionsToRender().map(section => section.section);
  var sections_url = window.location.pathname;
  var data = JSON.stringify({"quantity": 0, "id": motivatorProductVariantID, "sections" : sectionsToRender, "sections_url" : sections_url });
  xhr.send(data);
}
//Motivator Product JS END

// card-product mobile popup
// $(document).on("click",".size-popup-variants-list-title svg",function(){
//     $(".size-popup-list-content").removeClass("is-visible");
//   $(".size-popup-variants-cover ul li").removeClass("active");
//   $(".size-popup-variants-list-button button").addClass("disable");
// });

// $(document).on("click",".size-popup-variants-cover ul li",function(){
//   $(this).siblings().removeClass("active");
//   $(this).addClass("active");
//   if( $(this).addClass("active")){
//     $(".size-popup-variants-list-button button").removeClass("disable");
//   }
// })
//*************************** collection product bundle start **************************
  $('.bundle-builder-text-content[data-bundle-item="1"]').show();
  var bundleStep =  $(".bundle-builder-section").data("collection-step");
 function currentActivestep(){
        $(".bundle-builder-pagination").closest(".bundle-builder-number-content").removeClass("is-active");
     var get_currentActive=$(".bundle-builder-text-content.active")[1];
   if(get_currentActive){
       var currentIndex=get_currentActive.getAttribute("data-bundle-item");
      $(".bundle-builder-pagination[data-bundle-item="+currentIndex+"]").closest(".bundle-builder-number-content").addClass("is-active");
   }

 
 }
currentActivestep();
  
  // Click event on the bundle number content
  $(document).on("click", ".bundle-builder-pagination", function () {
    // Get the data-bundle-item value of the clicked item
    var bundleItem = $(this).data("bundle-item");

    // Hide all content sections
    $(".bundle-builder-text-content").removeClass("active");

    // Show the matching content section based on data-bundle-item
    $(
      '.bundle-builder-text-content[data-bundle-item="' + bundleItem + '"]'
    ).addClass("active");
  });

  // upsell product cart drawer
  $(".bundle-open-event").on("click", function () {
    $(".bundle-product-slider").owlCarousel({
      nav: true,
      dots: true,
      loop: false,
      margin: 15,
      responsive: {
        0: {
          items: 1,
        },
        1200: {
          items: 1,
        },
      },
    });
  });
  // Click event on the bundle popup
  $(document).on("click", ".bundle-open-event", function () {

    $(this)
      .closest(".bundle-product-item")
      .find(".bundle-product-popup-main")
      .addClass("popup-open");
//       setTimeout(() => {
//   $("#Bar-option-template--23911639581005__bundle_builder_r89eBf-Finish-0").trigger("click");
//         alert("clicked");
// }, 4000);
  });
  // Click event on the bundle popup remove
  $(document).on("click", ".bundle-close-event", function () {
    $(this).closest(".bundle-product-item").find(".bundle-product-popup-main").removeClass("popup-open");
  });

  //size selector button
  if ($("body").hasClass("template--collection")) {
    var interval = setInterval(function () {
      // Ensure that the wrapper is present
      if ($(".size-lineitem-wrapper").length > 0) {
        // Hide bundle button, show size selector button
        $(".bundle-product-popup-main .bundle-product-button").hide();
        $(".bundle-product-popup-main .bundle-carat-add-to-cart").show();
        $(".size-selector-box-button").show();
      } else {
        // Show bundle button, hide size selector button
        $(".bundle-product-popup-main .bundle-product-button").show();
        $(".size-selector-box-button").hide();
      }
      clearInterval(interval);
    }, 100);
  }

  //Size line item append input under form
  $(document).on(
    "click",
    ".bundle-product-popup-main .size-line-item-options",
    function () {
      // Add 'active' class to the clicked size option and remove it from siblings
      $(this).addClass("active").siblings().removeClass("active");

      // Find and show the bundle product button, enable pointer events
      $(this)
        .closest(".bundle-product-popup-main")
        .find(".bundle-product-button")
        .show()
        .css("pointer-events", "auto");

      // Hide the size selector button
      $(this)
        .closest(".bundle-product-popup-main")
        .find(".size-selector-box-button")
        .hide();
    }
  );

  //Variant change event
  function changeVariant(element) {
    // Initialize an empty array to store selected values from all fieldsets
    var selectedValues = [];
    var bundleParentDIV = element.closest(".bundle-product-item");
    // Loop through each fieldset within the '.quickview-variants-wrapper'
    bundleParentDIV.find(".bundle-product-select-options").each(function () {
      // Find the active label and get its 'data-value' attribute
      var activeValue = $(this).find("select").val() || "";
      if (activeValue) {
        selectedValues.push(activeValue); // Add the active value to the array
      }
    });

    // Join the selected values with " / " separator
    var comb = selectedValues.join(" / ");
    // Find the variant based on the combined value
    var selector = "[variant-title='" + comb + "']";
    var selectedVariant = bundleParentDIV.find(".all-variants " + selector);
    var selectedVariantID = selectedVariant.data("variants-id");
    var selectedVariantImage = selectedVariant.data("variant-image");
   
    var selectedVariantComparePrice = selectedVariant.data("variant-compareprice");
     var selected_free = selectedVariant.data("free-product");
   
     var selectedVariantRegPrice = selectedVariant.data("variant-price");
    if(selected_free == true){
       var selectedVariantRegPrice = "Free";
    }else{
       var selectedVariantRegPrice = selectedVariant.data("variant-price");
         if(typeof(selectedVariantRegPrice) == "undefined"){
   
           var get_variantElement=bundleParentDIV.find(".material_product_variants .material_json").each(function () {
         
             
         const productData = JSON.parse(this.textContent);
             console.log(productData);
             productData.forEach(materialProduct => {
             if(materialProduct.title == comb){
            
             }else{
              bundleParentDIV.find(".bundle-product-button.ajax-bundle-cart").attr("disabled","disabled");
              bundleParentDIV.find(".bundle-product-button.ajax-bundle-cart").text("Unavailable");
              bundleParentDIV.find(".bundle-product-button-main.mobile .bundle-product-button").attr("disabled","disabled");
             
              
             }
             if(materialProduct.option2 == selectedValues[1]){
      
                element.closest(".bundle-product-item").find(".bundle-product-image img").removeAttr("srcset");
                 element.closest(".bundle-product-item").find(".bundle-product-image img").removeAttr("sizes");
                 element.closest(".bundle-product-item").find(".bundle-product-image img").attr("src", materialProduct.featured_image.src);
             }
        
            });
          });
           
          }else{
           console.log("Hi");
              bundleParentDIV.find(".bundle-product-button.ajax-bundle-cart").removeAttr("disabled");
              bundleParentDIV.find(".bundle-product-button.ajax-bundle-cart").text("Add");
              bundleParentDIV.find(".bundle-product-button-main.mobile .bundle-product-button").removeAttr("disabled");
          
            
               var get_variantElement=bundleParentDIV.find(".material_product_variants .material_json").each(function () {
           
         const productData = JSON.parse(this.textContent);
            
             productData.forEach(materialProduct => {
             if(materialProduct.option2 == selectedValues[1] && materialProduct.option1 == selectedValues[0]){
              console.log(materialProduct);
             }
            });

                 
          });
          }
    }


    
    // Set the variant ID to the product AJAX cart button
    element.closest(".bundle-product-item").find(".bundle-product-image img").removeAttr("srcset");
     element.closest(".bundle-product-item").find(".bundle-product-image img").removeAttr("sizes");
    element.closest(".bundle-product-item").find(".bundle-product-image img").attr("src", selectedVariantImage);

    //Set product Price on variant change
    element.closest(".bundle-product-item").find(".product-regular-price").text(selectedVariantRegPrice);
    
       element.closest(".bundle-product-item").find(".bundle-product-popup-main .bundle-product-price.price__sale-inner del").text(selectedVariantRegPrice);
       var parentElement=element.closest(".bundle-product-item").find(".bundle-product-popup-main");
        parentElement.find(".bundle-product-price .price__sale-inner ins span").text(selectedVariantRegPrice);
    
     var parentElement_compare=element.closest(".bundle-product-item").find(".bundle-product-popup-main");
    parentElement_compare.find(".bundle-product-price .price__sale-inner del").text(selectedVariantComparePrice);

 element.closest(".bundle-product-item").find(".bundle-product-price del").text(selectedVariantComparePrice);
 element.closest(".bundle-product-item").find(".bundle-product-price ins span").text(selectedVariantRegPrice);
 
    element.closest(".bundle-product-item").find(".product-compared-price").text(selectedVariantComparePrice);

     // Set the variant ID to the product AJAX cart button
     bundleParentDIV.find(".ajax-bundle-cart").attr('data-variant-image', selectedVariantImage);
     bundleParentDIV.find(".ajax-bundle-cart").attr('data-bundle-variantid', selectedVariantID);
       bundleParentDIV.find(".ajax-bundle-cart").attr('data-variant-price', selectedVariantRegPrice);
     bundleParentDIV.find(".ajax-bundle-cart").attr('data-variant-compareprice', selectedVariantComparePrice);
    
  }

  $(document).on("change", ".bundle-select-dropdown-ajax", function () {
    changeVariant($(this));
  });
  
  //select metfiled carat change event
  $('.bundle-product-select').on('change', function() {
    // Get the selected option value
    var selectedValue = $(this).val();
    // Set the value of the data-meta-size-option attribute
    $(this).closest('.product-item-content').find('.bundle-product-button').attr('data-meta-size', selectedValue);
  });
  
  //select metfiled carat change trigger
  $(document).on("click", ".size-line-item-options", function () {
        var selectedMetaValue = $(this).attr("data-meta-size-option");
      // Find the corresponding option in the select dropdown and set it as the selected option
      $(this).closest(".bundle-product-item").find(".bundle-product-option-content").each(function () {
          // Find the select inside the current bundle-product-option-content and update its value
          $(this).find("option[value='" + selectedMetaValue + "']").prop("selected", true).trigger("change");
        });
  });

    
  //Popup variant change event
    $(document).on("click",".bundle-popup-product-content .product__swatches label", function() {
        // Get the variant value from the clicked label's 'title' attribute
        var selectedVariantValue = $(this).closest("li").find("input").val();
        // Remove 'is-active' class from all sibling labels
        $(this).closest(".bundle-popup-product-content .product__swatches").find("label").removeClass("is-active");

        // Add 'is-active' class to the clicked label
        $(this).addClass("is-active");

        // Find the corresponding option in the select dropdown and set it as the selected option
        $(this).closest(".bundle-product-item").find(".bundle-product-option-content").each(function () {
          console.log("testtt");
            // Find the select inside the current bundle-product-option-content and update its value
            $(this).find("option[value='" + selectedVariantValue + "']").css("border","1px solid");
            $(this).find("option[value='" + selectedVariantValue + "']").prop("selected", true).trigger("change");
          });
      });

  //product add to cart
  // Define the function to count spans and update the text
    function updateProductCount(element) {
        // Get all span elements within the closest '.bundle-builder-product-content-main'
        var $spanElements = $(element).closest('.bundle-builder-product-content-main').find('.bundle-array-product-item');
    
        // Get the count of span elements
        var spanCount = $spanElements.length;
    
        // Set the text of the element with class 'bundle-product-count' to spanCount
        $('.bundle-product-count').text('(' + spanCount + ')');
        $('.bundle-product-count').attr('product-count',spanCount);
        var datastep=$('.bundle-builder-section').data("collection-step");
     
        if(spanCount == datastep) {
          $('.product-popup-add-button').removeClass('disable');
        } else {
          $('.product-popup-add-button').addClass('disable');
        }
      // Toggle the display of .bundle-product-previe-text based on spanCount
      if (spanCount > 0) {
          $('.bundle-product-previe-text').css('display', 'inline-block');
      } else {
          $('.bundle-product-previe-text').css('display', 'none');
      }
    }
    
    //Check which step is selected
    function stepProgress() {
  
     $('.bundle-builder-number-content').each(function() {
       var numberIndex = $(this).find('.bundle-builder-pagination').data('bundle-item');
       var addedItemIndex = $(".bundle-array-products").find('[data-section-index="' + numberIndex + '"]');
       if (addedItemIndex.length > 0) {
        $(this).addClass('active');
            currentActivestep();
       }
       else{
         $(this).removeClass('active');
            currentActivestep();
       }
     });
   
    }

  //Update bundle item in the popup
    function updateBundlePopup() {
      $(".product-item-main > *").remove();
      // Check if there are any bundle-array-product-item elements
      if ($('.bundle-array-product-item').length > 0) {
          $('.bundle-array-products .bundle-array-product-item').each(function() {
              // Get the data from each item
              var productImage = $(this).attr('bundle-product-image');
              var product_free= $(this).attr('data-product-free');
              if(product_free !="true"){
                var productPrice = $(this).attr('bundle-product-price');
              }else{
                var productPrice ="Free";
              }
              
              var productComparePrice = $(this).attr('bundle-product-compareprice');
              var productTitle = $(this).attr('bundle-product-title');
              var productId = $(this).attr('data-bundle-array-productid');
              var productIndex = $(this).attr('data-section-index');
              
              // Create HTML structure for each product
              var productHTML = `
                  <div class="product-item">
                      <div class="bundle-product-image">
                          <img src="${productImage}" alt="${productTitle}">
                      </div>
                      <div class="product-item-content">
                          <div class="card-product__title product-content-text">
                              ${productTitle}
                          </div>
                          <div class="bundle-product-popup-price">
                              <div class="price__sale-inner">
                                  <div class="price_product compare-price product-item-compare-price">
                                      ${productComparePrice}
                                  </div>
                                  <div class="price_product product-item-price" ${product_free}>
                                      ${productPrice}
                                  </div>
                              </div>
                          </div>
                      </div>
                      
                      <div class="bundle-product-quantity-main" style="display:none">
                          <button type="button" tabindex="0" class="bundle-product-quantity-button remove-ajax-popup-bundle-cart" data-popup-section-index="${productIndex}" data-popup-product-id="${productId}">-</button>
                          <span class="bundle-product-quantity-button">1</span>
                          <button disabled="disabled" type="button" tabindex="0" class="bundle-product-quantity-button">+</button>
                      </div>
                      <div style="display:none" class="bundle-product-button button remove-ajax-popup-bundle-cart" data-popup-section-index="${productIndex}" data-popup-product-id="${productId}">
                          Remove
                      </div>
                  </div>
              `;
          
              // Append the HTML to the container
              $('.bundle-popup-section-v2 .product-item-main').append(productHTML);
          });
      } 
    }

   //Update bundle item in the total price
    function updateBundlePice() {
      var totalPrice = 0;
      var totalComparePrice = 0;
    
      // Check if there are any product items
      if ($('.bundle-array-product-item').length > 0) {
        // Loop through each product item
        $('.bundle-array-products .bundle-array-product-item').each(function() {
          // Get the price and compare price from the attributes and parse them
          var price = parseFloat($(this).attr('bundle-product-price').replace(/[^0-9.-]+/g, '')); // Remove dollar sign and parse
          
           var get_price_condtion =$(this).attr('data-product-free');
          if(get_price_condtion !="true"){
             var price = parseFloat($(this).attr('bundle-product-price').replace(/[^0-9.-]+/g, ''));
          }else{
            var price=0;
          }
          
          
          var comparePrice = parseFloat($(this).attr('bundle-product-compareprice').replace(/[^0-9.-]+/g, '')); // Remove dollar sign and parse
    
          // Accumulate the prices
          totalPrice += price;
          totalComparePrice += comparePrice;
        });
    
        // Update the total price and compare price in the popup
        var currency_symbol = $('.product-popup-item-price.productprice').attr('data-currency-symbol');
        $('.product-popup-item-price.productprice').text(currency_symbol + totalPrice.toFixed(2)); // Set the total price
        $('.product-popup-item-price.compareprice').text(currency_symbol + totalComparePrice.toFixed(2)); // Set the total compare price
      }
    }
   //check next step
   function checkNextStep() {
     if ($(".bundle-array-products").find(".bundle-array-product-item[data-section-index='1']").length > 0) {
       $(".bundle-builder-wrapper").find(".bundle-builder-add-main .bundle-builder-add-text.next-step").show();
       $(".bundle-builder-wrapper").find(".bundle-builder-add-main .bundle-builder-add-text.add-text").hide();
     }else {
       $(".bundle-builder-wrapper").find(".bundle-builder-add-main .bundle-builder-add-text.add-text").show();
        $(".bundle-builder-wrapper").find(".bundle-builder-add-main .bundle-builder-add-text.next-step").hide();
     }
  }

  //bundleproduct validation
    function bundleproductValidation() {
      $('.bundle-builder-number-content').each(function() {
        var $this = $(this);
        var numberIndex = $this.find('.bundle-builder-pagination').data('bundle-item');
        // Check if the current element has the class 'active'
        if ($this.hasClass('active')) {
            // Show the matching product popup description based on bundle-popup-index
            $('.bundle-popup-section-v2').find(".product-popup-description[bundle-popup-index='" + numberIndex + "']").hide();  // Hide the matching popup description
        } else {
            // Hide the product popup descriptions that don't match
            $('.bundle-popup-section-v2').find(".product-popup-description[bundle-popup-index='" + numberIndex + "']").show();  // Show the non-active ones
        }
    });
  }
  
  //bundleproduct info
    function bundleproductInfo() {
    if ($('.bundle-array-products .bundle-array-product-item').length > 0) {
          $('.bundle-product-info').hide();
          $('.bundle-product-item-content').show();
      } else {
          $('.bundle-product-info').show();
          $('.bundle-product-item-content').hide();
      }
    }

  //show/hide next step on click add to cart
  $(document).on("click", ".bundle-product-button-add", function () {
    // Hide / Show the clicked 'Add' button
    $(this).hide();
      $(this).siblings(".remove-ajax-bundle-cart").show();
  
      $(this).closest(".bundle-builder-text-content").find(".bundle-product-button-add").not(this).addClass("disable");
      $(this).closest(".bundle-builder-text-content").find(".bundle-product-button-main.desktop").addClass("disabled");
      // // Get the bundle text hide / show
      // $(this).closest(".bundle-builder-wrapper").find(".bundle-builder-add-main .bundle-builder-add-text").hide();
    setTimeout(function () {
      checkNextStep();
    }, 100);
  });

  // $(document).on("click", ".bundle-product-button.mobile", function () {
  //   // Hide / Show the clicked 'Add' button
  //   $(this).show();
  //   $(this).closest('.product-item-content').find('.remove-ajax-bundle-cart').hide();
  // });

  //Add product to the bundle array
  $(document).on("click", ".ajax-bundle-cart", function () {
    var bundleVariantID = $(this).attr("data-bundle-variantid");
    var bundleProductID = $(this).data("bundle-array-productid");
    var bundleProductMetasize = $(this).attr("data-meta-size");
    var bundleProductindex = $(this).closest('.bundle-builder-text-content').attr("data-bundle-item");
    var bundleProductImage = $(this).attr("data-variant-image");
    var bundleProducteprice = $(this).attr("data-variant-price");
    var bundleProductCompareprice = $(this).attr("data-variant-compareprice");
    var bundleProductTitle =  $(this).attr("data-product-title");
    var bundleProductFree =  $(this).attr("data-product-free");
    
    // Create a new span element with the data attributes
    var newSpan = '<span class="bundle-array-product-item" data-product-free="'+bundleProductFree +'" data-bundle-array-productID="' + bundleProductID + '" data-bundle-array-variantid="' + bundleVariantID + '" data-bundle-array-metasize="' + bundleProductMetasize + '"data-section-index="' + bundleProductindex + '"bundle-product-image="' + bundleProductImage +  '"bundle-product-price="' + bundleProducteprice + '"bundle-product-compareprice="' + bundleProductCompareprice + '"bundle-product-title="' + bundleProductTitle + '"></span>';

    // Append the new span to the .bundle-array-products container
    $(this).closest('.bundle-builder-product-content-main').find(".bundle-array-products").append(newSpan);
    // $('.bundle-product-previe-text').css('display', 'inline-block');
      
    // Update product count
     updateProductCount(this);

    // step progress
      stepProgress();

    //Update bundle item in the popup
    updateBundlePopup();

   //Update bundle item in the total price
    updateBundlePice();

   //Update bundle product validation
    bundleproductValidation();

   //Update bundle product info
    bundleproductInfo();

   //add to cart first tab trigger
    $('.bundle-builder-number-content').each(function() {
      var $this = $(this);
      var numberIndex = $this.find('.bundle-builder-pagination').data('bundle-item');
  
      // Check if the current element does NOT have the class 'active'
      if (!$this.hasClass('active')) {
          if (numberIndex == 1) {
            currentActivestep();
             $(this).find('.bundle-builder-pagination').trigger('click');
            return false; // This will break the loop
          }
      }
   });

      // Find all items with the class 'bundle-array-product-item'
    var $productItems = $('.bundle-array-product-item');

    // Check if the length of product items is equal to 4
    if ($productItems.length === bundleStep) {
      // $('.bundle-builder-add-text.final-bundle-ajax-step').show();
      // $('.bundle-product-button-text').hide();
      // $('.bundle-builder-add-text.next-step').hide();
      $(".bundle-builder-add-content").addClass("disabled");
    }else{
      $('.bundle-builder-add-text.final-bundle-ajax-step').hide();
    }
});
  
  //Next step button tab change
  $(document).on("click", ".bundle-product-next-text", function () {
    
    $('.bundle-builder-number-content').each(function() {
        var $this = $(this);
        var numberIndex = $this.find('.bundle-builder-pagination').data('bundle-item');

        // Check if the current element does NOT have the class 'active'
        if (!$this.hasClass('active')) {
            // Trigger click on the current pagination
            $(".bundle-builder-content .bundle-builder-number-content").removeClass("active");
            $this.find('.bundle-builder-pagination').trigger('click');
           currentActivestep();
            return false; // Break the loop after the first inactive item is found
        }
    });
    document.querySelector('#bundle_container').scrollIntoView();
    
});

  //product remove to cart
  $(document).on("click", ".remove-ajax-bundle-cart", function () {
    // Get the bundle product ID from the button
    var bundleProductID = $(this).data("bundle-array-productid");

    // Get the bundle text hide / show
    $(this).closest(".bundle-builder-wrapper").find(".bundle-builder-add-main .bundle-builder-add-text").show();
    $(this).closest(".bundle-builder-text-content").find('.bundle-product-add-to-cart').show();
    $(this).closest(".bundle-builder-text-content").find('.bundle-product-next-to-cart').hide();
    $(this).closest(".bundle-builder-wrapper").find(".bundle-builder-add-main .bundle-builder-add-text.next-step").hide();
    $(this).closest(".bundle-product-item").find(".bundle-product-opeion-button-add").show();

    // Find the span to remove based on the bundle product ID and variant ID
    var spanToRemove = $('.bundle-array-products span[data-bundle-array-productid="' + bundleProductID + '"]');


    // Check if the span exists and remove it
    if (spanToRemove.length) {
      spanToRemove.remove();
    }

    // Hide / Show the clicked 'Add' button
    $(this).hide();
    $(this).siblings(".bundle-product-button-add").show();
    $(this).closest(".bundle-builder-text-content").find(".bundle-product-button-add").removeClass("disable");
    $(this).closest(".bundle-builder-text-content").find(".bundle-product-button-main").removeClass("disabled");
    // $('.bundle-product-previe-text').css('display', 'none');

    // Update product count
     updateProductCount(this);

    //Update step progress
    stepProgress();

    // Remove the parent product-item div when the remove button is clicked
    // $(this).closest('.bundle-popup-section-v2 .product-item').remove();
    // $(this).addClass('click');

    //Update bundle item in the popup
      updateBundlePopup();

    //Update bundle item in the total price
     updateBundlePice();

    //Update bundle product validation
     bundleproductValidation();

    //Update bundle product info
     bundleproductInfo();

    if($(".bundle-builder-add-content").hasClass("disabled")){
      $(".bundle-builder-add-content").removeClass("disabled");
    }
    $(this).closest(".bundle-builder-text-content").find('.bundle-product-opeion-button-add').removeClass('disable');
  });

    //Update bundle item in the popup remove button
    $(document).on("click", ".remove-ajax-popup-bundle-cart", function () {
      var bundlepopupsectionIndex = $(this).attr('data-popup-section-index');
      var bundlepopupproductId = $(this).attr('data-popup-product-id');

     $('.bundle-builder-text-content[data-bundle-item="' + bundlepopupsectionIndex + '"]').find('.remove-ajax-bundle-cart[data-bundle-array-productid="' + bundlepopupproductId + '"]').trigger('click');
      //empty thai tyare trigger
       // Check if the product-item-main has any child elements
        if ($('.product-item-main').children().length === 0) {
            $('.bundle-product-popup-main-v2').removeClass('popup-open');
        }
    });

   // $(document).on("click", ".bundle-product-button-main.desktop .bundle-product-add-to-cart", function () {
   //  $(this).closest(".bundle-builder-text-content").find(".bundle-product-button-main.desktop .bundle-product-add-to-cart").not($(this)).addClass("disable");
   // });
  
  $(document).on("click", ".bundle-product-add-to-cart", function () {
    $(this).hide(); // Hide the clicked element
    $(this).closest(".bundle-product-button-main").find(".bundle-product-next-to-cart").show(); // Show the next step button
    $(this).closest(".bundle-product-item").find(".bundle-product-button-add").trigger('click');
    $(this).closest(".bundle-product-item").find(".bundle-product-opeion-button-add").hide();
    $(this).closest(".bundle-builder-text-content").find('.bundle-product-opeion-button-add').addClass('disable');
  });
  
   //step number text change
  $(document).on("click", ".bundle-builder-number-content", function () {
    var $this = $(this); // Cache the clicked element
    var nextStepText = $this.attr('next-step-text'); // Get the next step text
    $('.bundle-builder-step-text').text(nextStepText);
    // $this.addClass('section-active');
    // $this.siblings('.bundle-builder-number-content').removeClass('section-active');
    if (!$this.hasClass('active')) { // Check if this element does NOT have the class 'active'
        // Set the text in the target element
      checkNextStep();
      $('.bundle-builder-add-text.add-text').show()
      $('.bundle-builder-add-text.next-step').hide();
    } else {
      $('.bundle-builder-add-text.add-text').hide()
      $('.bundle-builder-add-text.next-step').show();
    }
  });
  
  $(document).on("click", ".bundle-product-next-to-cart", function () {
      $(this).hide(); // Hide the clicked element
      $(this).closest(".bundle-product-button-main").find(".bundle-product-add-to-cart").show(); // Show the add to bundle button
  });

  //bundle product popup v2
    $(".previe-popup-open").on("click", function () {
      $('.bundle-product-popup-main-v2').addClass("popup-open");
    });
     $(".bundle-product-popup-main-v2 .bundle-close-event").on("click", function () {
      $('.bundle-product-popup-main-v2').removeClass("popup-open");
    });
  
  // bundle product button show/hide
    $(window).on('scroll', debounce(function() {
    var $footerSection = $('.shopify-section-group-footer-group');
    var $bundleSection = $('.bundle-builder-add-main');
    var footerTop = $footerSection.offset().top;
    var footerBottom = footerTop + $footerSection.outerHeight();
    var scrollTop = $(window).scrollTop();
    var windowHeight = $(window).height();
  
    // Check if the section is in the viewport
    if (scrollTop + windowHeight > footerTop && scrollTop < footerBottom) {
      $bundleSection.hide(); // Hide if in viewport
    } else {
      $bundleSection.show(); // Show if out of viewport
    }
  }, 100)); // Adjust the wait time as needed

  // bundle product button show/hide


  $(window).scroll(function(){
    var screenWidth=$(window).width();
    if(screenWidth > 592){
        if ($(this).scrollTop() > 200) {
        $(".bundle-builder-add-main").css({"opacity":"1"});
    } else {
         $(".bundle-builder-add-main").css({"opacity":"0"});
    }
    }else{
        if ($(this).scrollTop() > 100) {
        $(".bundle-builder-add-main").css({"opacity":"1"});
    } else {
         $(".bundle-builder-add-main").css({"opacity":"0"});
    }
    }
  
});
 // $(document).on("click",".bundle-button-cart-ajax", function () {
 //    if ($(".bundle-array-product-item").length === 3) {
 //       // Loop through each bundle product item to get the variant ID
 //        $(".bundle-array-product-item").each(function () {
 //            const variantID = $(this).data("bundle-array-variantid");
 //            const qty = 1; // Set the quantity you want to add to the cart

 //            // Call the function to add each variant individually
 //            addToCartBundleJS(qty, variantID);
 //        });
 //    }
 //  });

  $(document).on("click", ".bundle-button-cart-ajax", function () {
       var bundleStep =  $(".bundle-builder-section").data("collection-step");
   
     let bundleCount = getTheCookie('bundleCount'); // Check if the cookie exists
      console.log("Initial bundleCount:", bundleCount);
      if (bundleCount === null) {
        bundleCount = 1; 
       setTheCookie('bundleCount', 1, 1);  // Initialize with 1-day expiration
        console.log("Cookie not found, initializing to 1");
      } else {
        // If it exists, convert the value to an integer
        bundleCount = parseInt(bundleCount);
        console.log("Existing cookie value:", bundleCount);
      } 
    
    const bundleItems = [];
    var bundleId = new Date().getTime();
    
    // bundle product add to cart drawer
    if ($(".bundle-array-product-item").length === bundleStep) {
        // Loop through each bundle product item to get the variant ID
        $(".bundle-array-product-item").each(function () {
            var bundleVariantID = $(this).data("bundle-array-variantid");
            var qty = 1; // Set your quantity here or get it from an input if necessary
            var size_lineItem = $(this).data("bundle-array-metasize");
            console.log("size_lineItem ",size_lineItem);
            var item = {
                id: bundleVariantID, // Push the id directly
                quantity: qty,
                properties: { bundle_id: bundleId, Size: size_lineItem } // Include click count in properties
            };

            // Push the item object into the bundleItems array
            bundleItems.push(item);
        });

        // Call the function to add each variant to the cart
        if (bundleItems.length > 0) {
            addToCartBundleJS(bundleItems,$(this), bundleCount); // Pass the array of data
        }
    }
  });

// Function addToCartBundleJS
  function addToCartBundleJS(bundleItems,element,bundleCount) {
    var cartDrawer = document.querySelector("cart-drawer");
    var sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.section);
    var sections_url = window.location.pathname;

    // Make a single fetch request to add all items
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            items: bundleItems,  // Send the entire array of items
            sections: sectionsToRender,
            sections_url: sections_url,
        }),
    })
    .then(response => response.json())
    .then(response => {
        if (jQuery('body').hasClass('ajax-cart-type-drawer')) {
            // cartDrawer.renderContents(response);
            // $(element).closest('.bundle-popup-section-v2').find('.bundle-close-event').trigger('click');
            // if($(".bundle-product-popup-main.popup-open").length > 0){
            //   $(".bundle-product-popup-main").find(".bundle-close-event").trigger('click');
            // }
            // cartDrawer.open();
            // cartBubbleUpdate();
           window.location.href = "/checkout";
        } else {
            window.location.href = "/checkout";
        }
        // On success, increment the bundleCount
        bundleCount += 1;
        setTheCookie('bundleCount', bundleCount, 1); // Update the cookie
        console.log("Updated bundleCount:", bundleCount); 
    })
    .catch(error => {
        console.error("Error adding item to cart:", error);
    });
  }

  let throttleTimeout = null;
  function observeCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");
  
    if (cartDrawer) {
      const observer = new MutationObserver(function (mutations) {
        if (!throttleTimeout) {
          throttleTimeout = setTimeout(() => {
            throttleTimeout = null; // Reset throttle
          }, 1000); // 1-second throttle to prevent repeated calls
        }
      });
  
      observer.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
    }
  }
  // Initialize observer
  observeCartDrawer();

  $(document).on("click",".cart-bundle-remove-button", function () {
      var $clickedBundle = $(this).closest(".cart-drawer-bundle-product-main");
      var bundleId = $(this).closest(".cart-drawer-bundle-product-main").attr("data-bundle-id");
      var bundleItems = $(this).closest(".cart-drawer-bundle-product-main").find(".cart-bundle-item");
      var bundleIndexProperty;
      var removeItems = {};
       // Loop through each bundle item
      bundleItems.each(function () {
        // Get the variant ID of the bundle item
        // var bundleVariantID = $(this).attr("data-bundle-variant-id");
        var bundleVariantKey = $(this).attr("data-bundle-item-key");
        
        // Find the corresponding cart item by matching the variant ID
        // var matchingCartItem = $('.cart-item[data-item-variant-id="' + bundleVariantID + '"][data-bundle-item="' + bundleId + '"]');
        var matchingCartItem = $('.cart-item[data-item-key="' + bundleVariantKey + '"][data-bundle-id="' + bundleId + '"]');
        
        // If a matching cart item is found, call the remove function
        
        if (matchingCartItem.length) {
          removeItems[bundleVariantKey] = 0;
        }
      });
      console.log("removeItems:: ", removeItems);
      removeProduct(removeItems);
   // Immediately invoke the async function
  });
  
  //Remove Bundle Product from the cart
  function removeProduct(removeItems) {
    return new Promise((resolve, reject) => {
      let bundleCount = getTheCookie('bundleCount'); // Check if the cookie exists
      
      // Open the cart drawer
      var cartDrawer = document.querySelector("cart-drawer");
      var sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.section);
      var sections_url = window.location.pathname;
      $.ajax({
        url: "/cart/update.js?bundle_remove_items",
        method: "POST",
        data: {
          updates: removeItems,
          sections: sectionsToRender, 
          sections_url: sections_url,
        },
        dataType: "json",
        success: function (response) {
          cartDrawer.renderContents(response);
        },
        error: function (error) {
          console.error("Error updating product:", error.responseText);
        },
      });
    });
  }

  // Upsell product add button disable
  function updateButtonClass(selectElement) {
    var selectedOption = $(selectElement).find('option:selected');
    var upsellProductBtn = $(selectElement).closest('.upsell-product-container').find('.upsell-product-btn');
    if ($(selectedOption).attr('data-select-value')) {
        upsellProductBtn.addClass('disable'); // Add 'disble' class if "Select" is chosen
      }else {
        upsellProductBtn.removeClass('disable'); // Remove 'disble' class for valid selection
      }
    }
    // On dropdown change, check the selected value and update the button
    $(document).on('change', '.upsell_variant_select', function() {
      updateButtonClass(this);
    });



// Number of coins lineitem plus/minus code
  function updateLineItems() {
      var variantValue = parseInt($('.personalised-number-of-items.active').attr('data-option-value'));
      var lineItemCount = $('.personalised-gemstone-item').length;
      // Remove extra items if variantValue is less than the current line item count
      if (variantValue < lineItemCount) {
          $('.personalised-gemstone-item:gt(' + (variantValue - 1) + ')').remove();
      } else if (variantValue > lineItemCount) {
          for (var i = lineItemCount + 1; i <= variantValue; i++) {
              var newItem = $('.personalised-gemstone-item').first().clone();
              newItem.find('.personalised-item-number').text('#' + i + ' *');
              newItem.find('input').each(function() {
                  var inputName = $(this).attr('name');
                  var parts = inputName.split('[');
                  var dynamicValue = parts[1].substring(0, parts[1].length - 1);
                  var newInputName = parts[0] + '[' + dynamicValue + i + ']'; // Appending 'i' to the dynamic value
                  $(this).attr('name', newInputName);
              });
              $('.personalised-gemstone-item:last').after(newItem);
          }
      }
  }

//Motivator Product JS Start
  var motivatorProduct = false;
  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (event) {
     function currentActivestep(){
      $(".bundle-builder-pagination").closest(".bundle-builder-number-content").removeClass("is-active");
     var get_currentActive=$(".bundle-builder-text-content.active")[1];
  var currentIndex=get_currentActive.getAttribute("data-bundle-item");
  $(".bundle-builder-pagination[data-bundle-item="+currentIndex+"]").closest(".bundle-builder-number-content").addClass("is-active");
 }
      currentActivestep();

      var target = event.target;
      if (target.classList.contains('click_gift')) {
        var isChecked = target.checked;
        fetch('/cart.json')
          .then(response => response.json())
          .then(data => {
            var items = data.items;
            var foundMotivatorProduct = items.some(item => item.handle === motivatorProductHandle);
            if (isChecked && !foundMotivatorProduct) {
              addMotivatorProduct(motivatorProductVariantID);
            } else if (!isChecked) {
              removeMotivatorProduct(motivatorProductVariantID);
            }
          });
      }
    });
  });

  function addMotivatorProduct(motivatorProductVariantID) {
      var xhr = new XMLHttpRequest();
      var url = "/cart/add.js";
      xhr.open("POST", url, true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          var parsedState = JSON.parse(xhr.responseText);
          document.querySelector('cart-drawer').renderContents(parsedState);
          $(".click_gift").prop("checked", true);
        }
      };
      var cartDrawer = document.querySelector('cart-drawer');
      var sectionsToRender = cartDrawer.getSectionsToRender().map(section => section.section);
      var sections_url = window.location.pathname;
      var data = JSON.stringify({"quantity": 1, "id": motivatorProductVariantID, "sections" : sectionsToRender, "sections_url" : sections_url });
      xhr.send(data);
  }
  
  function removeMotivatorProduct(motivatorProductVariantID) {
      var cartDrawer = document.querySelector('cart-drawer');
      var xhr = new XMLHttpRequest();
      var url = "/cart/change.js";
      xhr.open("POST", url, true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          var parsedState = JSON.parse(xhr.responseText);
          document.querySelector('cart-drawer').renderContents(parsedState);
          $(".click_gift").prop("checked", false);
        }
      };
      var cartDrawer = document.querySelector('cart-drawer');
      var sectionsToRender = cartDrawer.getSectionsToRender().map(section => section.section);
      var sections_url = window.location.pathname;
      var data = JSON.stringify({"quantity": 0, "id": motivatorProductVariantID, "sections" : sectionsToRender, "sections_url" : sections_url });
      xhr.send(data);
  }
  //Motivator Product JS END

// card-product mobile popup
// $(document).on("click",".size-popup-variants-list-title svg",function(){
//     $(".size-popup-list-content").removeClass("is-visible");
//   $(".size-popup-variants-cover ul li").removeClass("active");
//   $(".size-popup-variants-list-button button").addClass("disable");
// });

// $(document).on("click",".size-popup-variants-cover ul li",function(){
//   $(this).siblings().removeClass("active");
//   $(this).addClass("active");
//   if( $(this).addClass("active")){
//     $(".size-popup-variants-list-button button").removeClass("disable");
//   }
// })
// 🔁 Re-apply country size logic on Stone Size variant change
(function () {
  const showCountrySizes = (countryCode) => {
    $('[data-country-name]').hide();

    if (
      ['DE', 'AT', 'NL', 'CH'].includes(countryCode) ||
      $('body').hasClass('germany') || $('body').hasClass('austria') ||
      $('body').hasClass('netherlands') || $('body').hasClass('switzerland')
    ) {
      $('[data-country-name="DE,AT,NL,Ch"]').show();
    } else if (
      ['SE', 'NO', 'DK', 'FI'].includes(countryCode) ||
      $('body').hasClass('sweden') || $('body').hasClass('norway') ||
      $('body').hasClass('denmark') || $('body').hasClass('finland')
    ) {
      $('[data-country-name="SE,NO,DK,FI"]').show();
    } else if (
      ['GB', 'IE', 'AU', 'NZ'].includes(countryCode) ||
      $('body').hasClass('united-kingdom') || $('body').hasClass('Ireland') ||
      $('body').hasClass('australia') || $('body').hasClass('new-zealand')
    ) {
      $('[data-country-name="UK,IE,AU,NZ"]').show();
    } else if (
      ['FR', 'BE'].includes(countryCode) ||
      $('body').hasClass('france') || $('body').hasClass('belgium')
    ) {
      $('[data-country-name="FR,BE"]').show();
    } else {
      $('[data-country-name="US"]').show();
    }
  };

  const applyCountrySizeLogic = () => {
    const code = window.detectedCountry || $('.body_element').data('market_code') || 'US';
    showCountrySizes(code);
  };

  // Initial IP-based detection
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 2000);

  fetch('https://ipinfo.io/json', { signal: controller.signal })
    .then(res => res.json())
    .then(data => {
      clearTimeout(timeout);
      window.detectedCountry = data.country || 'US';
      applyCountrySizeLogic();
    })
    .catch(() => {
      window.detectedCountry = $('.body_element').data('market_code') || 'US';
      applyCountrySizeLogic();
    });

  // Observe carat variant change
  const sizeObserver = new MutationObserver(() => {
    applyCountrySizeLogic();
  });

  const config = { childList: true, subtree: true };

  const interval = setInterval(() => {
    const target = document.querySelector('[data-country-name]');
    if (target) {
      sizeObserver.observe(document.body, config);
      clearInterval(interval);
    }
  }, 200);
})();


});